import React from 'react';
import { Box, Text, VStack, Progress } from '@chakra-ui/react';
import { getCssVariable } from '../Utils/utils';

const HealthMetricsComponent = ({ metrics = [] }) => {


  return (
    <VStack spacing={4} align="stretch" width="100%">
      {metrics.map((metric, index) => {
        const hasValidScore = metric.score && metric.score.value !== null && !metric.isDataMissing;

        // Get progress variant from data (e.g., "primary-success-color")
        const progressVariant = metric.progress?.variant || 'progress-secondary';
        const progressValue = hasValidScore ? metric.progressWidth : 0;
        
        // Map score to color based on ranges (like the design shows)
        const getProgressColor = (score) => {
          if (score >= 67) return '#62B524'; // Green for 67-100
          if (score >= 33) return '#FFB349'; // Yellow/Orange for 33-66
          return '#FF8D83'; // Red for 0-32
        };
        
        const progressColor = hasValidScore ? getProgressColor(metric.progressWidth) : '#D9D9D9';

        return (
          <Box
            key={`${metric.name?.text || index}`}
            width={`var(--container-card-width, 100%)`}
            minHeight={`var(--container-card-height, 141px)`}
            borderRadius={`var(--container-card-border-radius, 8px)`}
            borderWidth={`var(--container-card-border-width, 1px)`}
            opacity={`var(--container-card-opacity, 1)`}
            gap={`var(--container-card-gap, 8px)`}
            padding={`var(--container-card-padding, 16px)`}
            background={`var(--container-card-background, var(--White, #FFFFFF))`}
            border={`var(--container-card-border, 1px solid #A5AEAE)`}
            p={4}
            overflow="visible"
          >
            <VStack align="stretch" width="100%">
              {/* Metric Name */}
              <Text
                fontFamily={`var(--${metric.name?.variant || 'body-md-min-reg'}-font-family, Roboto)`}
                fontWeight={`var(--${metric.name?.variant || 'body-md-min-reg'}-font-weight, 400)`}
                fontSize={`var(--${metric.name?.variant || 'body-md-min-reg'}-font-size, 16px)`}
                lineHeight={`var(--${metric.name?.variant || 'body-md-min-reg'}-line-height, 150%)`}
                letterSpacing={`var(--${metric.name?.variant || 'body-md-min-reg'}-letter-spacing, 0px)`}
                textAlign={`var(--${metric.name?.variant || 'body-md-min-reg'}-text-align, center)`}
                textTransform={`var(--${metric.name?.variant || 'body-md-min-reg'}-text-transform, uppercase)`}
                color={`var(--${metric.name?.variant || 'body-md-min-reg'}-color, var(--Dusky-Teal, #203433))`}
                
              >
                {metric.name?.text || "Metric"}
              </Text>

              {/* Score Display */}
              <Box textAlign="left">
                {hasValidScore ? (
                  <>
                    <Text
                      as="span"
                      fontFamily={`var(--${metric.score?.variant || 'headline-lg-min'}-font-family, Sora)`}
                      fontWeight={`var(--${metric.score?.variant || 'headline-lg-min'}-font-weight, 800)`}
                      fontSize={`var(--${metric.score?.variant || 'headline-lg-min'}-font-size, 24px)`}
                      lineHeight={`var(--${metric.score?.variant || 'headline-lg-min'}-line-height, 120%)`}
                      letterSpacing={`var(--${metric.score?.variant || 'headline-lg-min'}-letter-spacing, 0px)`}
                      color={`var(--${metric.score?.variant || 'headline-lg-min'}-color, var(--Dusky-Teal, #203433))`}
                    >
                      {metric.score.value}
                    </Text>
                    <Text
                      as="span"
                      fontFamily={`var(--${metric.scoreSuffix?.variant || 'body-md-min-reg'}-font-family, Roboto)`}
                      fontWeight={`var(--${metric.scoreSuffix?.variant || 'body-md-min-reg'}-font-weight, 400)`}
                      fontSize={`var(--${metric.scoreSuffix?.variant || 'body-md-min-reg'}-font-size, 16px)`}
                      lineHeight={`var(--${metric.scoreSuffix?.variant || 'body-md-min-reg'}-line-height, 150%)`}
                      letterSpacing={`var(--${metric.scoreSuffix?.variant || 'body-md-min-reg'}-letter-spacing, 0px)`}
                      color={`var(--${metric.scoreSuffix?.variant || 'body-md-min-reg'}-color, var(--Dusky-Teal, #203433))`}
                      ml={metric.scoreSuffix?.marginLeft || "8px"}
                    >
                      {metric.scoreSuffix?.text || "/100"}
                    </Text>
                  </>
                ) : (
                  <>
                    <Text
                      as="span"
                      fontFamily={`var(--${metric.score?.variant || 'headline-lg-min'}-font-family, Sora)`}
                      fontWeight={`var(--${metric.score?.variant || 'headline-lg-min'}-font-weight, 800)`}
                      fontSize={`var(--${metric.score?.variant || 'headline-lg-min'}-font-size, 24px)`}
                      lineHeight={`var(--${metric.score?.variant || 'headline-lg-min'}-line-height, 120%)`}
                      letterSpacing={`var(--${metric.score?.variant || 'headline-lg-min'}-letter-spacing, 0px)`}
                      color={`var(--${metric.score?.variant || 'headline-lg-min'}-color, var(--Dusky-Teal, #203433))`}
                    >
                      ?
                    </Text>
                    <Text
                      as="span"
                      fontFamily={`var(--${metric.scoreSuffix?.variant || 'body-md-min-reg'}-font-family, Roboto)`}
                      fontWeight={`var(--${metric.scoreSuffix?.variant || 'body-md-min-reg'}-font-weight, 400)`}
                      fontSize={`var(--${metric.scoreSuffix?.variant || 'body-md-min-reg'}-font-size, 16px)`}
                      lineHeight={`var(--${metric.scoreSuffix?.variant || 'body-md-min-reg'}-line-height, 150%)`}
                      letterSpacing={`var(--${metric.scoreSuffix?.variant || 'body-md-min-reg'}-letter-spacing, 0px)`}
                      color={`var(--${metric.scoreSuffix?.variant || 'body-md-min-reg'}-color, var(--Dusky-Teal, #203433))`}
                      ml={metric.scoreSuffix?.marginLeft || "8px"}
                    >
                      {metric.scoreSuffix?.text || "/100"}
                    </Text>
                  </>
                )}
              </Box>

              {/* Progress Bar */}
              <Box width="100%">
                                 
                                                                                                                                       <Progress
                    value={progressValue}
                    role="progressbar"
                    aria-valuenow={progressValue}
                    aria-valuemin={0}
                    aria-valuemax={100}
                    aria-labelledby={`${metric.name?.text || 'Metric'} score is ${Math.round(progressValue)}%`}
                    aria-label={`${metric.name?.text || 'Metric'} score is ${Math.round(progressValue)}%`}
                                         size={metric.progressSize || 'sm'}
                    sx={{
                      '& > div': {
                        backgroundColor: progressColor,
                        borderRadius: '8px'
                      }
                    }}
                 />
              </Box>

                             {/* Description */}
               <Text
                 fontFamily={`var(--${metric.description?.variant || 'body-sm-min-reg'}-font-family, Roboto)`}
                 fontWeight={`var(--${metric.description?.variant || 'body-sm-min-reg'}-font-weight, 400)`}
                 fontSize={`var(--${metric.description?.variant || 'body-sm-min-reg'}-font-size, 16px)`}
                 lineHeight={`var(--${metric.description?.variant || 'body-sm-min-reg'}-line-height, 150%)`}
                 letterSpacing={`var(--${metric.description?.variant || 'body-sm-min-reg'}-letter-spacing, 0px)`}
                 color={`var(--${metric.description?.variant || 'body-sm-min-reg'}-color, #000000)`}
                 textAlign="left"
                 wordBreak="break-word"
                 overflowWrap="break-word"
                 maxWidth="100%"
                 mb={0}
               >
                 {metric.description?.text || "Need more information"}
               </Text>
            </VStack>
          </Box>
        );
      })}
    </VStack>
  );
};

export default HealthMetricsComponent;
